export interface ImageMetadata {
  width: number;
  height: number;
  sizeBytes: number;
  mimeType: string;
}

/**
 * Compresses an image file to reduce file size and extracts metadata
 * @param file - The image file to compress
 * @returns Promise<{ base64: string; metadata: ImageMetadata }> - Base64 encoded compressed image and metadata
 */
export const compressImage = (file: File): Promise<{ base64: string; metadata: ImageMetadata }> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target?.result as string;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const MAX_WIDTH = 600;
        const scaleSize = MAX_WIDTH / img.width;
        canvas.width = MAX_WIDTH;
        canvas.height = img.height * scaleSize;

        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Failed to get canvas context'));
          return;
        }
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const base64 = canvas.toDataURL('image/jpeg', 0.7);
        
        // Extract metadata
        const metadata: ImageMetadata = {
          width: canvas.width,
          height: canvas.height,
          sizeBytes: file.size,
          mimeType: file.type || 'image/jpeg',
        };
        
        resolve({ base64, metadata });
      };
      img.onerror = (err) => reject(err);
    };
    reader.onerror = (err) => reject(err);
  });
};
